import styled from 'styled-components';

export const ArticleContainer = styled.div`
  margin: 0 10% 0%;
  @media (max-width: 720px) {
    margin: 0;
    padding-bottom: 16px;
  }
  .head {
    font-size: clamp(22px, 2vw, 48px);
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #675b5a;
    padding: 50px 0 25px;
    @media (max-width: 720px) {
      padding: 35px 0 25px;
    }
  }
  .subHead {
    color: #7e5c5c;
  }
  .container {
    overflow: auto;
    display: flex;
    gap: 30px;
    padding: 0 12px 8px;
    align-items: stretch;
    &::-webkit-scrollbar {
      display: none;
    }
    @media (max-width: 720px) {
      gap: 16px;
    }
    .innerContainer {
      flex-basis: 30%;
      @media (max-width: 720px) {
        min-width: 265px;
      }
      border-radius: 12px;
      box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.15);
      .imageSection {
        img {
          width: 100%;
          border-radius: 12px 12px 0 0;
        }
      }
      .textSection {
        padding: 12px;
        .title {
          font-size: clamp(16px, 2vw, 20px);
          font-weight: 600;
          color: #5f6c37;

          margin-bottom: 10px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }

      .description {
        border-top: 1px solid #ccdb99;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: clamp(12px, 2vw, 16px);
        padding-top: 14px;
        color: #242914;
      }
    }
  }
  .viewAllButton {
    border-radius: 10px;
    background-color: #ef4e5e;
    width: 45%;
    margin: 34px auto 22px;

    @media (max-width: 720px) {
      width: 93%;
      margin: 18px auto 0;
    }
    p {
      font-size: clamp(15px, 2vw, 22px);
      font-weight: 600;
      text-align: center;
      color: rgba(255, 255, 255);
      padding: 12px 0;
      @media (max-width: 720px) {
        padding: 16px 0px;
      }
    }
  }
  &.lowOpacity {
    opacity: 0.4;
  }
`;
